<script>
import VueCharts from 'vue-chartjs'

export default {
    name: 'StackBarChart',
    extends: VueCharts.Bar,
    props: {
        titleLeft: String,
        data: Object,
        colorBar: String,
        yAxisTicks: Boolean,
        maxStep: {
            type: Number,
            default: 5
        },
        legendLabel: {
            type: Object,
            default: () => ({
                display: true,
                labels: {
                    usePointStyle: true,
                    fontSize: 14,
                    fontColor: '#8A97AA',
                    padding: 24,
                },
                title: {
                    padding: {
                        left: 20
                    }
                }
            })
        }
    },
    methods: {
        render() {
            let max = this.data.maxCountChart ? this.data.maxCountChart : this.getMaxCount()
            let maxSize = Math.ceil(max / this.maxStep) * this.maxStep
            this.renderChart({
                labels: this.data.labels,
                datasets: this.data.datasets
            }, {
                responsive: true,
                maintainAspectRatio: false,
                borderRadius: 20,
                legend: this.legendLabel,
                plugins: {
                    datalabels: {
                        display: false
                    }
                },
                scales: {
                    xAxes: [
                        {
                            stacked: true,
                            maxBarThickness: 25,
                            borderRadius: 15,
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                fontSize: 14,
                                fontColor: '#8A97AA'
                            }
                        }
                    ],
                    yAxes: [
                        {
                            stacked: true,
                            gridLines: {
                                display: false
                            },
                            ticks: {
                                display: this.yAxisTicks,
                                min: 0,
                                max: maxSize,
                                stepSize: Math.ceil(max / 5),
                                fontSize: 14,
                                fontColor: '#8A97AA'
                            },
                            scaleLabel: {
                                display: false,
                                labelString: this.titleLeft,
                                fontColor: '#8A97AA',
                                fontFamily: 'segoe ui',
                                fontSize: 14,
                            }
                        }
                    ]
                },
                tooltips: {
                    enabled: true,
                    displayColors: false,
                    callbacks: {
                        title: (tooltipItems, data) => {
                            let text = ''
                            let tooltips = this.data.tooltip[tooltipItems[0]['index']] ? this.data.tooltip[tooltipItems[0]['index']] : []
                            tooltips.forEach((item, index) => {
                                if (item.name) {
                                    text += `${index === 0 ? '' : '\n'}` + `${item.name}: ${item.value}`
                                }
                            })
                            return text.trim()
                        },
                        label: function (tooltipItem, data) {
                            let label = []
                            if (!data.datasets[0]['data_chart']) {
                                return ''
                            }
                            // custom by Number of calls by time chart
                            data.datasets[0]['data_chart'][tooltipItem['index']]['unconnected']['end_cause'].forEach((item, index) => {
                                let totalCalls = parseInt(data.datasets[0]['data_chart'][tooltipItem['index']]['total_calls'])
                                if (item.value) {
                                    label.push(`  • ${item.value}: ${item.count} (${Math.round(parseInt(item.count) / totalCalls * 10000) / 100}%)`)
                                }
                            })
                            // custom by Number of calls by time chart
                            return label
                        },
                        footer: function (tooltipItem, data) {
                            return ''
                        }
                    },
                    backgroundColor: '#000',
                    titleFontSize: 14,
                    titleFontStyle: 'normal',
                    titleFontColor: '#FFF',
                    bodyFontColor: '#FFF',
                    bodyFontSize: 14,
                    xPadding: 12,
                    yPadding: 12,
                },
                animation: false
            })
        },
        getMaxCount() {
            let dataArr = this.data.datasets.map(i => i.data)
            let sumArr = dataArr.reduce((acc, array) => acc.map((sum, i) => sum + array[i]), new Array(dataArr[0] ? dataArr[0].length : 0).fill(0))
            return Math.max(...sumArr)
        }
    },
    watch: {
        data: {
            deep: true,
            handler: function () {
                this.render()
            }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    ul.custom-legends {
        border: 1px solid black;
        list-style-type: none;
        padding-left: 0px;

    }

    ul.custom-legends li {
        border: 1px solid lightgray;
        list-style-type: none;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: left;
    }

    .dot {
        border-radius: 50px;
        height: 10px;
        width: 10px;
        margin-right: 10px;
    }
}
</style>
